import {
  deserializeDateRange,
  type DateRange,
} from "@repo/app-types/entities/dateRange";
import { useMemo } from "react";
import { useAppSelector } from "../../hooks/hook.js";
import { selectCompany } from "../company/companySlice.js";

/** Reads the company's `performance_default_date_range` setting into a
 * luxon-based `DateRange`. Returns `undefined` when the setting isn't set or
 * the company hasn't loaded yet, in which case callers should fall back to
 * their own default. */
export function useCompanyDefaultDateRange(): DateRange | undefined {
  const company = useAppSelector(selectCompany);
  const serialized = company?.settings.performance_default_date_range ?? null;

  return useMemo(
    () => (serialized ? deserializeDateRange(serialized) : undefined),
    [serialized],
  );
}
